import { render, staticRenderFns } from "./TrainingCust.vue?vue&type=template&id=f9f2c9ae&"
import script from "./TrainingCust.vue?vue&type=script&lang=js&"
export * from "./TrainingCust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports